export const styles = theme => ({
    formControl: {
        minWidth: 500
    },
    redirectButton: {
        marginTop: -15
    }
});
